export default {
  layout: {
    aiCommandCentre: {
      badge: 'مركز قيادة الذكاء الاصطناعي',
      line:
        'تخصيص تلقائي للناقلين والسائقين، تخطيط مسارات بوكلاء ذكاء اصطناعي، تنبيهات ذكية ووكلاء IA — برج تحكم واحد يدير عملياتك اللوجستية.',
      cta: 'وكلاء IA',
    },
  },
};
